import React from "react";
import { Language } from "../../types";
import { StoreFunctions } from "../context/Store";
import LanguageBlockElement from "./LanguageBlockElement";
import AddSelectBlock from "./AddSelectBlock";

export interface LanguageSelectBlockProps {
  data: Language[];
  toggleLanguage: StoreFunctions["toggleLanguage"];
  setLanguageValue: StoreFunctions["setLanguageValue"];
  value: string;
  add: StoreFunctions["addLanguage"];
  onChange: StoreFunctions["setTempLanguage"];
}

export interface LanguageSelectBlockState {}

export const LanguageSelectBlock = (props: LanguageSelectBlockProps) => {
  const {
    data,
    toggleLanguage,
    setLanguageValue,
    value,
    add,
    onChange,
  } = props;
  return (
    <div className="search-select-block mb-5">
      <div className="heading-wrapper">
        <div className="row">
          <div className="col-6">Wybierz języki</div>
          <div className="col-6">Zaznacz stopień znajomości</div>
        </div>
      </div>
      {data.map((item, index) => (
        <LanguageBlockElement
          key={index}
          data={item}
          index={index}
          toggleLanguage={toggleLanguage}
          setLanguageValue={setLanguageValue}
        />
      ))}
      <AddSelectBlock
        value={value}
        add={add}
        onChange={onChange}
        placeholder="Inny (wpisz jaki)"
      />
    </div>
  );
};

export default LanguageSelectBlock;
